import type { ApiResponse } from '@skylabs-digital/react-proto-kit';

/**
 * Desenvuelve la respuesta cruda del connector de react-proto-kit 3.
 *
 * Desde v3 `ApiResponse<T>` es una union discriminada por `success`: `data`
 * solo existe en la rama exitosa. Las llamadas ad hoc del backoffice
 * (`connector.post(...)` para acciones que no son CRUD) ya venian envueltas
 * en `try/catch`, asi que la rama de error se convierte en excepcion y el
 * flujo del caller no cambia.
 */
export function unwrap<T>(res: ApiResponse<T>): T {
  if (!res.success) {
    throw new Error(res.message ?? 'Request failed');
  }
  return res.data;
}
